import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { Fragment } from 'react/jsx-runtime';
import { DefaultLink, LinkItem } from '../shared';
import styles from './FooterCompact.module.css';
import type { FooterCompactProps } from './types';
function FooterCompact(t0) {
  const $ = _c(9);
  const {
    text,
    Link: t1
  } = t0;
  const Link = t1 === undefined ? DefaultLink : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = classNames("bp-shared", styles.footer);
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = text.providerInfo;
  let t4;
  if ($[1] !== Link || $[2] !== text.links) {
    let t5;
    if ($[4] !== Link) {
      t5 = (t6, index) => {
        const {
          className,
          ...linkItemProps
        } = t6;
        return <Fragment key={index}><LinkItem Link={Link} {...linkItemProps} className={classNames(styles.link, className)} /></Fragment>;
      };
      $[4] = Link;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    t4 = text.links.map(t5);
    $[1] = Link;
    $[2] = text.links;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[6] !== t4 || $[7] !== text.providerInfo) {
    t5 = <footer className={t2}>{t3}{t4}</footer>;
    $[6] = t4;
    $[7] = text.providerInfo;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}
export default FooterCompact;